import { SectionHeader } from "./SectionHeader";

const TESTIMONIALS = [
  { name: "Laura M.", role: "Tienda de ropa", text: "Desde que uso CuadraAI dejé de perder cuentas en cuadernos. Ahora sé exactamente cuánto gano cada mes." },
  { name: "Carlos R.", role: "Ferretería", text: "El control de inventario me avisa antes de que se agoten los productos que más se venden." },
  { name: "Daniela P.", role: "Cafetería", text: "La IA me ayudó a identificar qué productos me dejaban menos margen. Cambié mi menú y mejoraron mis ganancias." },
];

export default function Testimonials({ C }) {
  return (
    <section style={{ padding: "64px 20px", maxWidth: 1080, margin: "0 auto" }}>
      <SectionHeader C={C} eyebrow="Testimonios" title="Negocios que ya confían en CuadraAI" />
      <div className="cq-grid-3" style={{ display: "grid", gap: 16, marginTop: 32 }}>
        {TESTIMONIALS.map((t, i) => (
          <div key={t.name} style={{
            background: C.bgCard, border: `1px solid ${C.border}`, borderRadius: 18,
            padding: 22, boxShadow: C.shadow, animation: `fadeIn 0.5s ease ${i * 0.05}s backwards`,
          }}>
            <div style={{ color: C.amber, fontSize: 14, marginBottom: 10 }}>★★★★★</div>
            <p style={{ color: C.text, fontSize: 13.5, lineHeight: 1.6, marginBottom: 16 }}>“{t.text}”</p>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <div style={{
                width: 34, height: 34, borderRadius: "50%",
                background: `linear-gradient(135deg, ${C.primary}, ${C.blue})`,
                color: "#fff", fontWeight: 800, fontSize: 13,
                display: "flex", alignItems: "center", justifyContent: "center",
              }}>{t.name[0]}</div>
              <div>
                <div style={{ color: C.text, fontWeight: 700, fontSize: 12.5 }}>{t.name}</div>
                <div style={{ color: C.muted, fontSize: 11.5 }}>{t.role}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
